import { ReactNode } from "react";
import { AnalyticsContext, AnalyticsContextState } from "./AnalyticsContext";

const localAnalytics: AnalyticsContextState = {
  setUser: () => {},
  trackEvent: () => {},
  setUserProperties: () => {},
  identifyVisitor: () => {},
};

export const LocalAnalyticsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <AnalyticsContext.Provider value={localAnalytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};
